import { Flex, Text } from "@chakra-ui/react";
import { Bundle } from "../../../types";
import { BundleCard } from "../../cards/BundleCard";
import { useMobileBreakpoint } from "../../../utils/useBreakpoints";

interface SlideInMenuBundlesListProps {
  bundles: any;
  text?: string;
}

export function SlideInMenuBundlesList({
  bundles,
  text,
}: SlideInMenuBundlesListProps) {
  const isMobile = useMobileBreakpoint();

  return (
    <Flex flexDirection="column" gap="16px">
      <Text
        fontSize="14px"
        lineHeight="160%"
        fontWeight={400}
        color="neutral.300"
        mb="8px"
      >
        {text}
      </Text>
      <Flex
        className="styled-scrollbar"
        flexDirection="column"
        flexGrow={1}
        gap="16px"
      >
        <Flex flexDirection="column" gap="16px">
          {bundles.map((bundle: Bundle, index: number) => (
            <BundleCard
              key={bundle.id || index}
              content={bundle}
              expanded={!isMobile}
              layout={{
                style: {
                  size: "s",
                  context: "bundle",
                  mode: "list",
                  rows: 1,
                  corners_top: "right",
                  corners_bottom: "right",
                  section_is_inset: false,
                },
                display: {
                  include_name: true,
                  include_author: true,
                  include_cover_image: true,
                  include_ribbon_badge: true,
                },
              }}
            />
          ))}
        </Flex>
      </Flex>
    </Flex>
  );
}
